import { render, staticRenderFns } from "./SupportTicketPreview.vue?vue&type=template&id=2f054e3c"
import script from "./SupportTicketPreview.vue?vue&type=script&lang=js"
export * from "./SupportTicketPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports